import { Link as TanStackLink, type LinkComponentProps } from '@tanstack/react-router';
import type { ReactNode } from 'react';

type WorkbenchLinkProps = Omit<LinkComponentProps<'a', any, string, string>, 'to'> & { href: string; children?: ReactNode };

export default function WorkbenchLink({ href, children, ...props }: WorkbenchLinkProps) {
  return (
    <TanStackLink to={href} {...props}>
      {children}
    </TanStackLink>
  );
}
